import { useCallback } from 'react';
import { IDepositInfo, IDepositItem } from '@/types';
import { useCommonParams, useLoading } from '@/hooks';
import { clickEventHandler } from '@/helpers';
import { Wrapper } from '@/components/templates/collectDepositList/CollectDepositList.styled';
import { IntersectionObserver } from '@/components/common';
import { DepositListItem } from '@/components/organisms';
import { COMPONENT_TYPE } from '@/const';

const CollectDepositList = (props: IDepositInfo) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [, setLoading] = useLoading();

  const handleClick = useCallback(
    async (item: IDepositItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,

        componentName: COMPONENT_TYPE.DEPOSIT,
      });
    },
    [commonParams, setLoading],
  );

  const renderComponent = (item: IDepositItem, index: number) => (
    <IntersectionObserver key={index} page={commonParams.page} {...item} componentName={COMPONENT_TYPE.DEPOSIT}>
      <DepositListItem {...item} onClick={() => handleClick(item)} />
    </IntersectionObserver>
  );

  return (
    <Wrapper>
      {ads.length > 0 &&
        ads.map((item: IDepositItem, index: number) => renderComponent(item, index))}
    </Wrapper>
  );
};
export default CollectDepositList;
